export default {
    list: {
        title: 'Team',
        subtitle: 'Gestisci i membri del tuo team',
        invite: 'Invita Membro',
        loading: 'Caricamento team...',
        addMember: 'Aggiungi Membro',
        allRoles: 'Tutti i ruoli',
        allStatuses: 'Tutti gli stati',
        searchPlaceholder: 'Cerca per nome o email...',
        rolePlaceholder: 'Filtra per ruolo',
        statusPlaceholder: 'Filtra per stato',
        description: 'Lista dei membri del tuo team',
        headers: {
            name: 'Nome',
            email: 'Email',
            role: 'Ruolo',
            status: 'Status',
            lastLogin: 'Ultimo Accesso',
            inviteDate: 'Data Invito',
            actions: 'Azioni',
        },
        noMembers: {
            title: 'Nessun membro del team trovato',
            message: 'Prova a modificare i filtri di ricerca',
            emptyMessage: 'Inizia aggiungendo il tuo primo membro del team',
            addFirst: 'Aggiungi Primo Membro',
        },
        modal: {
            addTitle: 'Invita Membro',
            editTitle: 'Modifica Membro',
            removeTitle: 'Rimuovi Membro',
            fields: {
                name: 'Nome',
                namePlaceholder: 'Inserisci nome',
                email: 'Email',
                emailPlaceholder: 'nome@azienda.com',
                firstName: 'Nome',
                firstNamePlaceholder: 'Inserisci nome',
                lastName: 'Cognome',
                lastNamePlaceholder: 'Inserisci cognome',
                role: 'Ruolo',
                rolePlaceholder: 'Seleziona il ruolo',
                status: 'Status',
                statusPlaceholder: 'Seleziona lo status',
                isActive: 'Attivo',
            },
            roles: {
                operator: 'Operatore',
                companyAdmin: 'Admin',
            },
            cancel: 'Annulla',
            save: 'Salva',
            create: 'Crea',
            invite: 'Invia Invito',
            confirmRemove: 'Rimuovi Membro',
            removeConfirmation: 'Sei sicuro di voler rimuovere {{name}} ({{email}}) dal team? Questa azione non può essere annullata.',
            sendNotificationEmail: 'Invia email di notifica all\'utente',
            success: {
                memberInvited: 'Invito inviato con successo',
                memberUpdated: 'Membro aggiornato con successo',
                memberRemoved: 'Membro rimosso con successo',
            },
            error: {
                emailRequired: 'L\'email è obbligatoria',
                invitingMember: 'Errore durante l\'invito del membro',
                updatingMember: 'Errore durante l\'aggiornamento del membro',
                removingMember: 'Errore durante la rimozione del membro',
            },
        },
        statusLabels: {
            active: 'Attivo',
            inactive: 'Inattivo',
        },
        actions: {
            edit: 'Modifica',
            remove: 'Rimuovi',
        },
        never: 'Mai',
        confirmDelete: 'Sei sicuro di voler eliminare questo membro del team?',
    },
};
